import wbRoutes from '@/features/jxxf/wb/wb.routes.js';
import jcRoutes from '@/features/jxxf/jc/jc.routes.js';
import pgRoutes from '@/features/jxxf/pg/pg.routes.js';

export default {
  path: 'jxxf',
  name: 'jxxf',
  component: { template: '<router-view></router-view>' },
  children: [wbRoutes, jcRoutes, pgRoutes]
};
